import { NudosButton } from "components/NudosComponents"
import CancelReservationSerialItem from "../CancelReservationSerialItem/CancelReservationSerialItem"
import { IFloatSelectSerialItem } from "../../../../FloatSelectSerial";

interface ICancelReservationModalContent {
  items: IFloatSelectSerialItem[];
  handleCancelReservation: () => void;
  setShouldCloseModal: (value: boolean) => void;
  isLoadingCancelReservation: boolean;
  orderId: string;
}

const CancelReservationModalContent = ({items, handleCancelReservation, setShouldCloseModal, isLoadingCancelReservation, orderId}: ICancelReservationModalContent) => {
  return (
    <div className="cancelReservationModal">
    <div className="subTitle">Estás a punto de cancelar la reserva en la orden N°{orderId}:</div>

    <div className="serialsList">
      {items.map((item, index) => (
        <CancelReservationSerialItem key={`${item.stockProductId}-${index}`} item={item} />
      ))}
    </div>

    <div className="confirmationSection">
      <div className="confirmationText">¿Seguro que deseas continuar?</div>
      <div className="buttonsContainer">
        <NudosButton
          isButtonLoading={false}
          buttonText="Mantener"
          customWidth="208px"
          customHeight="38px"
          handleClick={() => setShouldCloseModal(true)}
          colorPalette="secondary"
        />
        <NudosButton
          isButtonLoading={isLoadingCancelReservation}
          buttonText={isLoadingCancelReservation ? 'Cancelando reservas...' : 'Si, Cancelar todas la reserva'}
          customWidth="208px"
          customHeight="38px"
          handleClick={handleCancelReservation}
        />
      </div>
    </div>
  </div>
  )
}

export default CancelReservationModalContent